var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolumeLevel2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#888888;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M563.6,540.5c0,64.8,0,129.5,0,194.3c0,2.7,0.1,5.3-0.9,7.9c-2.6,6.9-10.5,9.7-16.9,5.9 c-1.6-0.9-3-2.1-4.3-3.4c-38.2-36.1-76.4-72.1-114.5-108.3c-2.6-2.5-5.1-3.6-8.8-3.6c-24.6,0.2-49.2,0.1-73.8,0.1 c-10.7,0-14.7-4.1-14.7-14.9c0-52.4,0-104.7,0-157.1c0-10.8,4-14.9,14.7-14.9c24.8,0,49.5-0.1,74.3,0.1c3.3,0,5.6-1,7.9-3.2 c38.1-36.1,76.3-72.2,114.5-108.3c1.3-1.3,2.7-2.5,4.2-3.5c6.6-4.3,14.9-1.3,17.5,6.2c0.8,2.5,0.8,4.9,0.8,7.4 C563.6,410.3,563.6,475.4,563.6,540.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M703.4,536c-0.4-31.3-11.3-62.7-33-90.2c-1.3-1.7-2.8-3.4-4-5.2c-4.1-6.1-3.8-11.4,1.3-16.7 c4.8-5.1,9.8-10.1,14.9-14.9c6.7-6.3,13.6-5.6,19.4,1.3c18,21.3,31.5,45,39.6,71.7c8.2,27.2,10.6,54.9,7,83.1 c-5,39.7-21,74.4-46.7,104.8c-5.5,6.5-12.3,7.4-18.7,1.7c-5.6-5-10.9-10.4-16-16c-5.2-5.6-5-11.1,0.4-17.9 c6.6-8.2,12.6-16.8,17.6-26.1C697.4,589.2,703.4,565.2,703.4,536z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M657.1,538.3c-0.4,25.2-7.3,46.2-21.2,64.8c-5.4,7.2-12.9,7.9-19.3,1.7c-4.6-4.4-9-8.9-13.5-13.5 c-7.3-7.3-7.8-11.1-2.5-19.7c11.2-18.3,12.5-37.3,3.6-56.8c-1.5-3.3-3.5-6.4-5.4-9.6c-2.7-4.6-2.4-9,0.9-13 c5.7-6.8,12-13.1,18.8-18.8c5.1-4.3,12.1-3.4,16.4,2.1c11.6,14.8,18.6,31.5,21.1,50.1C656.6,530.6,657.3,535.4,657.1,538.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeLevel2);
export default __webpack_public_path__ + "static/media/volumeLevel2.04c83005b9103b9623c0c2b79e899505.svg";
export { ForwardRef as ReactComponent };